import React from 'react'
import PropTypes from 'prop-types'

import timeHelper from 'lib/timeHelper'
import { hourFromMinutes } from 'lib/helper'

import Text from 'components/Text2'
import ShowHide from 'components/ShowHide2'
import Currency from 'components/Currency'
import PhoneNumber from 'components/PhoneNumber'

class AppointmentFullInfo extends React.Component {
   render() {

      const { appointment, user } = this.props
      const { dtoReservedAppointment: reservedAppointment, appointmentTime } = appointment
      const { appointmentCode, oneClickAppointmentValue: price, clientFullName, clientEmail, clientPhones } = reservedAppointment

      return (
         <div style={{ display: 'flex', flexFlow: 'column', alignItems: 'center' }}>

            {/* Appointment */}
            <div style={{ textAlign: 'left', width: '100%', marginBottom: 10 }}>
               <Text title underline>Consulta</Text>
               <ShowHide show={!!appointmentCode}>
                  <InfoItem title="Código da Consulta" value={appointmentCode ? appointmentCode : null} />
               </ShowHide>
               <InfoItem title="Horário" value={hourFromMinutes(appointmentTime)} />
               <InfoItem title="Valor" value={<Currency>{price}</Currency>} />
            </div>

            {/* User */}
            <div style={{ display: 'block', textAlign: 'left', width: '100%', marginBottom: 20 }}>
                  <Text title underline>Cliente</Text>
                  <InfoItem title="Nome" value={clientFullName} />
                  <InfoItem title="E-mail" value={clientEmail} />
                  <InfoItem title="Telefone" value={<PhoneNumber>{clientPhones}</PhoneNumber>} />
            </div>
         </div>
      )
   }
}

AppointmentFullInfo.propTypes = {
   appointment: PropTypes.object,
   user: PropTypes.object,
}

// InfoItem component
const InfoItem = (props) => {
   const color = props.color ? props.color : 'rgb(135,135,135)'
   return (
      <p style={{ margin: 0, marginBottom: 4, fontSize: 14 }}>
         <strong>{props.title}: </strong>
         <span style={{ color: color }}>{props.value}</span>
      </p>
   )
}

InfoItem.propTypes = {
   title: PropTypes.string.isRequired,
   value: PropTypes.any,
}
// END InfoItem component

export default AppointmentFullInfo



// WEBPACK FOOTER //
// ./src/components/AppointmentFullInfo/index.js